/**
 * Browser analytics (PostHog), switched per stack (TRA-1105).
 *
 * Pulumi writes POSTHOG_KEY and POSTHOG_HOST into /config.js only when the
 * stack sets platform:apps.platformV2.analytics.enabled. Without the key the
 * SDK is never initialized, and an uninitialized posthog-js sends nothing
 * (its remote-config fetch lives inside init), so an in-perimeter browser
 * never dials posthog.com. Every PostHog call in the app goes through here.
 */
import posthog from 'posthog-js'
import { config } from '../config'

interface PosthogTarget {
  key: string
  host: string
}

function resolveTarget(): PosthogTarget | null {
  const { POSTHOG_KEY: key, POSTHOG_HOST: host } = config
  if (!key) return null
  if (!host) {
    throw new Error('POSTHOG_HOST is required in window.__CONFIG__ when POSTHOG_KEY is set')
  }
  return { key, host }
}

const target = resolveTarget()

export function initAnalytics(): void {
  if (!target) {
    console.info('Analytics off: window.__CONFIG__ has no POSTHOG_KEY, so PostHog is not loaded')
    return
  }
  posthog.init(target.key, {
    api_host: target.host,
    defaults: '2026-05-30',
    person_profiles: 'identified_only',
  })
}

export function identifyAnalyticsUser(email: string): void {
  if (!target) return
  posthog.identify(email, { email })
}

export function resetAnalytics(): void {
  if (!target) return
  posthog.reset()
}
